module.exports = __webpack_public_path__ + "static/media/LoadingBars.bbc9123b.svg";